module.exports = __webpack_public_path__ + "img/banner_left.bd6f89c4.png";